import Vue from 'vue'
import store from '../store'
Vue.prototype.debug = true

function isIosorAndroid(data) {
  var dataString = JSON.stringify(data);
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  var iosdata = JSON.parse(dataString);
  if (isAndroid) {
    iosdata = JSON.stringify(iosdata);
    window.android.callAndroid(iosdata);
  } else if (isIOS) {
    void window.webkit.messageHandlers.callAndroid.postMessage(iosdata)
  }
  console.log(iosdata)
}

//原生调用JS
function nativeCallJs(jsondata, callback) {
  if (!jsondata) {
    console.warn('nativeCall参,请检查');
    return;
  }
  var data = typeof jsondata === 'string' ? JSON.parse(jsondata) : jsondata;
  // isIosorAndroid(data)
  //你的逻辑代码
  if (data.type == 4) {
    againAd(1);
  } else if (data.type == 5) {
    againAd(2, againAnswerJs);
  } else if (data.type == 6) {
    doubleForce()
  } else if (data.type == 7) {
    // doubleForce()
    tipsCard()
  }
  callback && callback(data)
}

window.nativeCallJs = nativeCallJs;

function nativeCallBack(params, callback, callbackparams) {
  var tmpType = Number(params.type);
  console.log("app给H5的params：" + JSON.stringify(params))
  if (tmpType == 3) {
    Vue.prototype.user_params = params || "";
    store.commit('setAppToken', params.token)
    sessionStorage.setItem("user_params", JSON.stringify(params));
    var bpScript = document.createElement("script");
    bpScript.setAttribute("src", "https://bigdata-h5.tuoluo.cn/userBehavior/web/prod/1.0.1/buryingPointWeb.js");
    bpScript.setAttribute("type", "text/javascript");
    let env = process.env.NODE_ENV == 'test' ? 'test' : 'prod';
    let user_params = Vue.prototype.user_params || JSON.parse(sessionStorage.getItem("user_params")) || "";
    let tlId = "";
    let version = user_params && user_params.version;
    if (user_params && user_params.tl_id && user_params.tl_id != "null") {
      tlId = user_params.tl_id
    }

    bpScript.onload = function () {
      //初始化代码
      Vue.prototype.$webBP = new window.$webBP({
        env,
        tlId,
        debug: true,
        appId: "tl3e2c3dfd836764a",
        version: '20210415'
      });
      console.log('Vue.prototype.$webBP', Vue.prototype.$webBP);
      callback && callback(callbackparams.eventId, callbackparams.pageName)
    }
    document.body.appendChild(bpScript);
  }
}

/**
 *
 * @param {跳转路径 path} router
 * @param {导航栏原生顶部字体颜色 0:黑色 1：白色，默认黑色} statusLight
 */
function openFullScreen(router, statusLight = 0, code, contentCode, signId, orderId) {
  Vue.prototype.$toast({
    type: 'loading',
    message: '跳转中...',
    forbidClick: true,
    duration: 1000
  })
  isIosorAndroid({
    type: 5,
    url: `${getHostEstate(router)}?pagename=tl_full_screen&statusLight=${statusLight}${code ? `&code=${code}` : ''}${contentCode ? `&contentCode=${contentCode}` : ''}${signId ? `&signId=${signId}` : ''}${orderId ? `&orderId=${orderId}` : ''}`,
    title: "",
    description: "",
    imgUrl: "",
    id: "",
    name: "",
  });
}

function appBack() {
  isIosorAndroid({
    type: -1,
    url: "",
    title: "",
    description: "",
    imgUrl: "",
    id: "",
    name: "",
  });
}

function appBackRefe() {
  isIosorAndroid({
    type: -2
  });
}

function nativeChangeLoginState(data) {
  // window.location.reload()
  console.log('转换前.....', data);
  let jsondata = typeof data === 'string' ? JSON.parse(data) : data
  console.log('转换后.....', jsondata);
  console.log('Vue.prototype.user_params', Vue.prototype.user_params);
  // Vue.prototype.user_params.token = jsondata.token
  Vue.set(Vue.prototype.user_params, 'token', jsondata.token)
  store.commit('setAppToken', jsondata.token)
  console.log('window.location/....', window.location);
  // window.location.reload()
}

window.nativeCallBack = nativeCallBack;
window.nativeMaiCallBack = nativeCallBack;
window.openFullScreen = openFullScreen;
window.appBack = appBack;
window.appBackRefe = appBackRefe;
window.nativeChangeLoginState = nativeChangeLoginState;



// WEBPACK FOOTER //
// ./src/plugin/nativeCall.js